import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import VehicleRenewalStatus from "../components/vehicleRenewalStatus";
import VehicleCumulativeInfo from "../components/vehicleCumulativeInfo";
import { useParams, Link, useNavigate} from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Vehicle_details_View = () => {
  useAuthRedirect();
  const { sno } = useParams();
  const navigate = useNavigate();

   const [transfer, setTransfer] = useState({});

   // put near top of the component
const [site, setSite] = useState({
  ok: true,
  name: "Infraconsoft",
  logo: null,
  address: "",
  email: "",
  phone: "",
  _ts: 0,
});

useEffect(() => {
  let ignore = false;
  (async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/siteinfo");
      const s = res?.data || {};
      let logo = s.logo || null;
      if (logo && !/^https?:\/\//i.test(logo)) {
        if (!logo.startsWith("/")) logo = `/${logo}`;
        logo = `${window.location.origin}${logo}`;
      }
      if (!ignore) {
        setSite({
          ok: !!s.ok,
          name: s.name || "Infraconsoft",
          logo,
          address: s.address || "",
          email: s.email || "",
          phone: s.phone || "",
          _ts: Date.now(),
        });
      }
    } catch (e) {
      console.error("Failed to load /siteinfo", e);
    }
  })();
  return () => { ignore = true; };
}, []);

  
    useEffect(() => {
        const fetchTransfer = async () => {
          if (!sno) return;
          try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_transfer_details?sno=${sno}`);
            if (response.data && response.data.transferDetails?.length > 0) {
                const items = response.data.transferDetails;
                console.log();
                

                const transferDetail = {
                    vcode: items[0].vehicle_code || "N/A",
                    insertDate : items[0].insert_time ||"N/A",
                    vnumber: items[0].vehicle_number || "N/A",
                    vname: items[0].vehicle_name || "N/A",
                    vehicleBranch: items[0].branch_code || "N/A",
                    vehicle_make: items[0].vehicle_make || "N/A",
                    model: items[0].model || "N/A",
                    invoiceNo: items[0].vehicle_invoice || "N/A",
                    vehicle_type: items[0].vehicle_type || "N/A",
                    vehicle_basis: items[0].vehicle_basis || "N/A",
                    chassis_num: items[0].chassis_num || "N/A",
                    engine_SlNo: items[0].engine_SlNo || "N/A",
                    vehicle_regdate: items[0].vehicle_regdate || "N/A",
                    vehicle_regno: items[0].vehicle_regno || "N/A",
                    purchase_date: items[0].purchase_date || "N/A",
                    vehicle_purfrom: items[0].vehicle_purfrom || "N/A",
                    Hypothecation: items[0].Hypothecation || "N/A",
                    purchese_amt: items[0].purchese_amt || "N/A",
                    insurance_date: items[0].insurance_date || "N/A",
                    renewal_date: items[0].renewal_date || "N/A",
                    insurance_number: items[0].insurance_number || "N/A",
                    insurance_amt: items[0].insurance_amt || "N/A",
                    premium_your: items[0].premium_your || "N/A",
                    insurance_company: items[0].insurance_company || "N/A",
                    Fc_date: items[0].Fc_date || "N/A",
                    Fc_renewaldate: items[0].Fc_renewaldate || "N/A",
                    rc_number: items[0].rc_number || "N/A",
                    permit_expirydate: items[0].permit_expirydate || "N/A",
                    permit_date: items[0].permit_date || "N/A",
                    roadtax_to: items[0].roadtax_to || "N/A",
                    roadtax_from: items[0].roadtax_from || "N/A",
                    cumulative: items[0].cumulative || "N/A",
                    vehicle_description: items[0].vehicle_description || "N/A",
                    fld_equipment: items[0].fld_equipment || "N/A",
                    fld_utilisation: items[0].fld_utilisation || "N/A",
                    fld_vehiclecondition: items[0].fld_vehiclecondition || "N/A",
                    remarks: items[0].remarks || "N/A",

                    
                    
                };

                setTransfer(transferDetail);
                console.log("Updated Header Details:", transferDetail);
            } else {
                console.warn("API Response does not contain expected data structure");
            }
            
            
          } catch (error) {
            console.error("Error fetching locations:", error);
          }
        };
    
        fetchTransfer();
      }, [sno]); 

     

const exportToExcel = () => {
  // Helper: format all date values into d/m/y
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr; // if not a valid date, return as-is
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  // ---------- Company header (minimal, merged across both columns) ----------
  const nameRow = [(site.name || "Infraconsoft").toUpperCase(), ""];
  const addrRow = [site.address || "", ""];
  const contactParts = [
    site.phone ? `Ph: ${site.phone}` : "",
    site.email ? `Email: ${site.email}` : ""
  ].filter(Boolean);
  const contactRow = [contactParts.join(" | "), ""];

  // ---------- Title row ----------
  const titleRow = ["Vehicle Details", ""];

  // ---------- Details (Field / Value) ----------
  const detailsRows = [
    ["Field", "Value"],
    ["Vehicle Code", transfer.vcode],
    ["Vehicle Name", transfer.vname],
    ["Branch", transfer.vehicleBranch],
    ["Entry Date", formatDate(transfer.insertDate)],
    ["Vehicle Number", transfer.vnumber],
    ["Make", transfer.vehicle_make],
    ["Model", transfer.model],
    ["Invoice No", transfer.invoiceNo],
    ["Type", transfer.vehicle_type],
    ["Basis", transfer.vehicle_basis],
    ["Chassis No", transfer.chassis_num],
    ["Engine Sl No", transfer.engine_SlNo],
    ["Reg Date", formatDate(transfer.vehicle_regdate)],
    ["Reg No", transfer.vehicle_regno],
    ["Purchase Date", formatDate(transfer.purchase_date)],
    ["Purchase From", transfer.vehicle_purfrom],
    ["Hypothecation", transfer.Hypothecation],
    ["Purchase Amount", transfer.purchese_amt],
    ["Insurance Date", formatDate(transfer.insurance_date)],
    ["Renewal Date", formatDate(transfer.renewal_date)],
    ["Insurance No", transfer.insurance_number],
    ["Insurance Amount", transfer.insurance_amt],
    ["Premium", transfer.premium_your],
    ["Insurance Company", transfer.insurance_company],
    ["FC Date", formatDate(transfer.Fc_date)],
    ["FC Renewal Date", formatDate(transfer.Fc_renewaldate)],
    ["RC Number", transfer.rc_number],
    ["Permit Date", formatDate(transfer.permit_date)],
    ["Permit Expiry", formatDate(transfer.permit_expirydate)],
    ["Road Tax From", formatDate(transfer.roadtax_from)],
    ["Road Tax To", formatDate(transfer.roadtax_to)],
    ["Cumulative", transfer.cumulative],
    ["Description", transfer.vehicle_description],
    ["Equipment", transfer.fld_equipment],
    ["Utilisation", transfer.fld_utilisation],
    ["Condition", transfer.fld_vehiclecondition],
    ["Remarks", transfer.remarks],
  ];

  // Spacer rows for breathing room
  const spacer = ["", ""];

  // Final AOA: header -> spacer -> title -> spacer -> details
  const exportData = [
    nameRow,
    addrRow,
    contactRow,
    spacer,
    titleRow,
    spacer,
    ...detailsRows,
  ];

  // Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(exportData);

  // Merge company header and title across two columns
  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // Company name
    { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }, // Address
    { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } }, // Phone/Email
    { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } }, // "Vehicle Details"
  ];

  // Column widths
  worksheet["!cols"] = [
    { wch: 25 }, // Field
    { wch: 40 }, // Value
  ];

  // Optional freeze: keep the title visible (row index is 0-based)
  // After: 0 name,1 addr,2 contact,3 spacer,4 title,5 spacer => freeze after row 5
  worksheet["!freeze"] = { xSplit: 0, ySplit: 6, topLeftCell: "A7", activePane: "bottomLeft" };

  // NOTE: Styling (bold, font size) needs SheetJS Pro / XLSX-Style.
  // If you have it, you can bold A1/A2/A3/A5 like below. Safe to leave as-is otherwise.
  const boldCells = ["A0", "A1", "A2", "A4"]; // 0-based in AOA -> BUT cell addresses are A1-based:
  ["A1", "A2", "A3", "A5"].forEach((cell) => {
    if (worksheet[cell]) worksheet[cell].s = { font: { bold: true } };
  });

  // Create workbook & export
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicle Details");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // Save (your original method)
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "VehicleDetails.xlsx";
  link.click();
};


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
      <h2 className="add-txt">Vehicle Details - View</h2>
      <p className="back-button" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
        <i className="fa-solid fa-backward"></i> Back
      </p>
    </div>
          
          <div>
            <Time />
          </div>
        </section>

        <div className="add-new-container">
  <button className="add-new-btn" onClick={exportToExcel}>
    <i className="fa-solid fa-file-excel"></i> Export to Excel
  </button>
</div><br></br>


        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vcode" value={transfer.vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Entry Date :</label>
                <input type="text" value={new Date(transfer.insertDate).toLocaleDateString("en-GB")} readOnly={true}/>
              </div>
            </div>

            
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Branch :</label>
                <input type="text" name="branch" value={transfer.vehicleBranch} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Invoice Number :</label>
                <input type="text" name="driver" value={transfer.invoiceNo}   readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vname" value={transfer.vname} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehno" value={transfer.vnumber} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Make :</label>
                <input type="text" name="vname" value={transfer.vehicle_make} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Model :</label>
                <input type="text" name="vehno" value={transfer.model} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Type:</label>
                <input type="text" name="vname" value={transfer.vehicle_type} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Basis :</label>
                <input type="text" name="vehno" value={transfer.vehicle_basis} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Chassis Number:</label>
                <input type="text" name="vname" value={transfer.chassis_num} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Engine SL.No :</label>
                <input type="text" name="vehno" value={transfer.engine_SlNo} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Reg Number:</label>
                <input type="text" name="vname" value={transfer.vehicle_regno} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Reg date:</label>
                <input type="text" name="vname" value={ transfer.vehicle_regdate ? new Date(transfer.vehicle_regdate).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Purchased From:</label>
                <input type="text" name="vname" value={transfer.vehicle_purfrom} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Purchased date:</label>
                <input type="text" name="vname" value={ transfer.purchase_date ? new Date(transfer.purchase_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Hypothecation with:</label>
                <input type="text" name="vname" value={transfer.Hypothecation} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input type="text" name="vehno" value={transfer.purchese_amt} readOnly={true} />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Insurance date:</label>
                <input type="text" name="vname" value={ transfer.insurance_date ? new Date(transfer.insurance_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>

              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={transfer.renewal_date} />(Insurance)
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance Number:</label>
                <input type="text" name="vname" value={transfer.insurance_number} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Insured amount:</label>
                <input type="text" name="vehno" value={transfer.insurance_amt} readOnly={true} />
              </div>
            </div>  

            <div className="form-row">
              <div className="form-group">
                <label>Ins. Premium Per Year:</label>
                <input type="text" name="vname" value={transfer.premium_your} readOnly={true} />
              </div>
            <div className="form-group">
                <label>Insurance Company:</label>
                <input type="text" name="vehno" value={transfer.insurance_company} readOnly={true} />
              </div>
            </div> 

           

            <div className="form-row">
              <div className="form-group">
                <label>FC Date:</label>
                <input type="text" name="vname" value={ transfer.Fc_date ? new Date(transfer.Fc_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={transfer.Fc_renewaldate} />(FC)
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>RC Book Number:</label>
                <input type="text" name="vname" value={transfer.rc_number} readOnly={true} />
              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={transfer.permit_expirydate} />(Rc)
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Permit date:</label>
                <input type="text" name="vname" value={ transfer.permit_date ? new Date(transfer.permit_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <label>Road Tax To Date:</label>
                <input type="text" name="vname" value={ transfer.roadtax_to ? new Date(transfer.roadtax_to).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Road Tax From Date:</label>
                <input type="text" name="vname" value={ transfer.roadtax_from ? new Date(transfer.roadtax_from).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <label>Last updated H M R:</label>
                <input type="text" name="vname" value={transfer.cumulative} readOnly={true} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle description:</label>
                <input type="text" name="vname" value={transfer.vehicle_description} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Equipment:</label>
                <input type="text" name="vname" value={transfer.fld_equipment} readOnly={true} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Utilisation:</label>
                <input type="text" name="vname" value={transfer.fld_utilisation} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Condition:</label>
                <input type="text" name="vname" value={transfer.fld_vehiclecondition} readOnly={true} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="vname" value={transfer.remarks} readOnly={true} />
              </div>
               <div className="form-group">
                            <label>Current Cum HMR :</label>
                            <VehicleCumulativeInfo vehicleCode={transfer.vcode} vBasis={transfer.vehicle_basis} />
                          </div>
            </div> 

           <Link to={`/vehicle_details_edit/${sno}`}> <div className="btn-cls">
              <button className="submit-btn">Edit this vehicle</button>
            </div>
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_details_View;
